module.exports = __webpack_public_path__ + "img/fourBg.50a438d6.jpg";